module.exports = __webpack_public_path__ + "img/InformationTechnology.e9290605.jpg";